<script setup>
import { onMounted, ref } from 'vue'
import { useAreaStore } from '@/stores/area'

const areaStore = useAreaStore()

const props = defineProps({
  area: {
    type: Object,
    default: () => ({})
  }
})

const errorMessage = ref('')

onMounted(() => {
  areaStore.getAllAreas()
})

const area = ref({ ...props.area })

const emits = defineEmits(['close'])

const submit = async () => {
  errorMessage.value = ''
  if (!area.value.name || area.value.name.trim() === '') {
    errorMessage.value = 'שם אזור נדרש'
    return
  }

  // בדוק אם כבר יש אזור בשם זה
  const existingArea = areaStore.areas.find(
    (a) => a.name?.trim()?.toLowerCase() === area.value.name.toLowerCase() && a.id !== area.value.id
  )
  if (existingArea) {
    errorMessage.value = 'כבר קיים אזור עם שם זה'
    return
  }

  const id = area.value.id
    ? await areaStore.updateArea(area.value)
    : await areaStore.createArea(area.value)

  emits('close', id)
}
</script>

<template>
  <form @submit.prevent="submit">
    <div class="flex flex-col gap-4">
      <div class="flex flex-col">
        <label for="name"> שם </label>
        <InputText id="name" v-model.trim="area.name" type="text" fluid autofocus />
        <Message v-if="errorMessage" severity="error" variant="simple" size="small">
          {{ errorMessage }}
        </Message>
      </div>

      <div class="flex gap-4">
        <Button fluid severity="secondary" outlined label="ביטול" @click="emits('close')" />
        <Button fluid label="שמירה" type="submit" :loading="areaStore.loading" />
      </div>
    </div>
  </form>
</template>
